import React, { Component } from 'react'

import GameState from './shared/GameState'
import mapImageSrc from './map.svg'

class TileView extends Component {

  constructor(props) {
    super(props)
    this.mapImage = new Image()
    this.mapImage.src = mapImageSrc
  }

  componentDidMount() {
    this.updateTile()
  }

  updateTile() {
    if (!this.canvas) return
    console.log('lol')
    const context = this.canvas.getContext('2d')
    const tileSize = this.mapImage.width / GameState.MAP_SIZE
    const sourceX = tileSize * this.props.x
    const sourceY = tileSize * this.props.y
    const sourceWidth = tileSize
    const sourceHeight = tileSize
    const destWidth = this.canvas.width
    const destHeight = this.canvas.height
    const destX = 0
    const destY = 0
    context.drawImage(this.mapImage, sourceX, sourceY, sourceWidth, sourceHeight, destX, destY, destWidth, destHeight)
  }

  render() {
    return (
      <canvas className="TileView" width="200" height="200" ref={canvas => this.canvas = canvas}/>
    )
  }

}

class WinLoseView extends Component {

  render() {
    return (
      <div className="WinLoseView">
        <div className="WinLoseView-Title">
          { this.props.victory ? 'You win!' : 'Game Over!' }
        </div>
        <div className="WinLoseView-Tiles">
          <div className="WinLoseView-Tile-Container">
            <TileView x={this.props.drunkard.x} y={this.props.drunkard.y}/>
            {
              !this.props.victory ?
              <div className="WinLoseView-Caption">Drunkard</div> : null
            }
          </div>
          {
            !this.props.victory ?
            <div className="WinLoseView-Tile-Container">
              <TileView x={this.props.driver.x} y={this.props.driver.y}/>
              <div className="WinLoseView-Caption">Driver</div>
            </div>
            : null
          }

        </div>
        <button onClick={() => window.location= '/'}>again?</button>
      </div>
    )
  }

}

export default WinLoseView



// WEBPACK FOOTER //
// ./src/WinLoseView.js